import PayerTypeStatusGlobalModal from "../../common/modal/PayerTypeStatusGlobalModal";
import WorkQDeferredTooltip from "./WorkQDeferredTooltip";

import classes from './StatusCell.module.css'

export default function StatusCellWrapper({children, itemKey, caseData}) {
    if (itemKey == 'case_data_payer_type') {
        return <div className={classes.status_cell_wrapper}>
            <PayerTypeStatusGlobalModal date={caseData?.case?.case_payer_type_date} user={caseData?.case?.case_payer_type_by}  mode={'type'}>                                  
                {children}
            </PayerTypeStatusGlobalModal>
        </div>
    }

    if (itemKey == 'case_data_payer_status') {
        return <div className={classes.status_cell_wrapper}>
            <PayerTypeStatusGlobalModal date={caseData?.case?.case_payer_status_date} user={caseData?.case?.case_payer_status_by}>                                  
                {children}
            </PayerTypeStatusGlobalModal>
        </div>
    }

    if (itemKey == 'case_gdq_staus_gdq_update') {
        return <div className={classes.status_cell_wrapper}>
            {/* || caseData?.case?.gdq_status_id != 9 */}
            <WorkQDeferredTooltip mode={'v3'} message={`Reason: ${caseData?.case?.other_gdq_status}`} disabled={!caseData?.case?.other_gdq_status || caseData?.case?.gdq_status_id != 13 }>
                {children}
            </WorkQDeferredTooltip>
        </div>
    }

    return <div className={classes.status_cell_wrapper}>
        {children}
    </div>
}